let appInfoCached = Object.create(null)

const platform = (() => {
  if (typeof window === 'undefined') {
    return {}
  }

  const u = navigator.userAgent
  return {
    iOS: /ipad|iphone|mac/i.test(u),
    Android: /android/i.test(u),
    Weixin: /micromessenger/i.test(u)
  }
})()

/**
 * 解析url param
 */
function getQueryStringArgs() {
  if (typeof window === 'undefined') {
    return {}
  }

  const qs = location.search.length > 0 ? location.search.substring(1) : ''
  const args = {}
  const items = qs.length ? qs.split('&') : []
  let item = null
  let name = null
  let value = null
  let i = 0
  const len = items.length
  const regx = new RegExp('(.*)=([^$].*)$', 'i')

  for (i = 0; i < len; i++) {
    item = items[i].match(regx)
    if (!item) {
      continue
    }
    // decodeURIComponent解码
    name = decodeURIComponent(item[1])
    // 移除某些版本的意外字符（换行符）
    const s = item[2].replace(/%0A/g, '')
    value = decodeURIComponent(s)
    if (name.length && !args[name]) {
      args[name] = value
    }
  }

  return args
}

/**
 * 更新app信息
 *
 * @param {object} target
 */
function updateAppInfo(target) {
  const app = {}

  for (const key in target) {
    if (Object.hasOwnProperty.call(target, key)) {
      const element = target[key]
      if (element !== null && element !== '') {
        // 键值全部转换为小写，防止部分参数小写部分大写的异常情况
        app[key.toLowerCase()] = target[key]
      }
    }
  }

  appInfoCached = { ...appInfoCached, ...app }
}

function getParam(name) {
  // 键值全部转换为小写，防止部分参数小写部分大写的异常情况
  return appInfoCached[name.toLocaleLowerCase()]
}

// 初始化参数
updateAppInfo(getQueryStringArgs())

export default {
  platform,
  getParam,
  updateAppInfo
}
